import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const Section = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const SectionContent = styled('div', {
  width: '100%',
  py: 24,
  px: 16,
  '@sm': {
    maxWidth: 576,
  },
  '@md': {
    maxWidth: 768,
  },
  '@lg': {
    maxWidth: 992,
  },
  '@xl': {
    maxWidth: 1200,
  },
});

export const StyledTicketCard = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 8,
  boxShadow: '$shadow1',
  overflow: 'hidden',
  px: 16,
  py: 20,
  '@md': {
    px: 32,
    py: 24,
  },
});

export const ShippingRouteContainer = styled('div', {
  display: 'flex',
  backgroundColor: '$secondary',
  justifyContent: 'center',
});

export const ShippingRouteDialogContainer = styled('div', {
  display: 'flex',
  backgroundColor: '$white',
  boxShadow: '$shadow1',
  height: '100vh',
  '@sm': {
    height: 'auto',
    borderRadius: 8,
    padding: 16,
  },
});

export const ShippingRouteDialogHeader = styled('div', {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  borderBottom: '1px solid $dbGray1',
  padding: 16,
});

export const SmallLabel = styled(Text, {
  color: '$typeGray',
  mb: 4,
  ...typography.body6,
  '@md': {
    ...typography.body5,
  },
});

export const TextContent = styled(Text, {
  color: '$primary',
  fontWeight: '600 !important',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '100%',
  maxWidth: 125,
  '@media(min-width: 375px)': {
    maxWidth: 150,
  },
  '@xl': {
    maxWidth: 240,
  },
});

export const MobilePortText = styled(Text, {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '100%',
  maxWidth: 110,
  '@media(min-width: 375px)': {
    maxWidth: 138,
  },
  '@media(min-width: 441px)': {
    maxWidth: 160,
  },
  '@sm': {
    maxWidth: 250,
  },
  '@md': {
    maxWidth: 300,
  },
});

export const MobileTextContent = styled(Text, {
  color: '$typeGray',
});

export const Dot = styled('div', {
  height: 6,
  width: 6,
  borderRadius: 99,
  backgroundColor: '$primary',
});

export const DateText = styled(Text, {
  ...typography.body5,
  mt: 4,
  mb: 12,
  color: '$typeGray',
  '@md': {
    ...typography.body3,
  },
});

export const TimeText = styled(Text, {
  ...typography.headline6,
  minWidth: 100,
  '@md': {
    ...typography.headline4,
  },
});

export const PortText = styled(Text, {
  ...typography.headline7,
  fontSize: 12,
  '@md': {
    ...typography.headline5,
  },
});

export const LocationText = styled(Text, {
  color: '$typeGray',
  ...typography.body5,
  '@md': {
    ...typography.body3,
  },
  fontWeight: '600 !important',
});

export const FacilityContentText = styled(LocationText, {
  color: '$typeBlack',
});

export const ShipText = styled(Text, {
  color: '$typeBlack',
  position: 'relative',
  display: 'flex',
  ...typography.headline6,
  '@md': typography.headline4,
});

export const CruiseText = styled(Text, {
  ...typography.body5,
  '@md': {
    ...typography.body2,
  },
  fontWeight: '600 !important',
});

export const FromPriceText = styled(Text, {
  color: '$typeGray',
  ...typography.body5,
  fontWeight: 600,
  '@lg': {
    ...typography.headline6,
  },
});

export const PriceText = styled(Text, {
  ...typography.headline5,
  '@md': {
    ...typography.headline4,
  },
  fontWeight: '700 !important',
});

export const ChairLeftText = styled(Text, {
  color: '$error',
  mt: 8,
  ...typography.body6,
  '@md': {
    ...typography.body4,
  },
  fontWeight: '600 !important',
});

export const AvailableFacilityContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  svg: {
    width: 16,
    height: 16,
  },
  '@md': {
    svg: {
      width: 24,
      height: 24,
    },
  },
});

export const AvailableFacilityText = styled(Text, {
  ml: 8,
  ...typography.body6,
  '@md': {
    ...typography.body5,
  },
  variants: {
    isAvailable: {
      true: {
        color: '$primary',
      },
      false: {
        color: '$disabled',
      },
    },
  },
});

export const styles = {
  priceContainer: {
    alignItems: 'flex-start',
    '@xl': {
      alignItems: 'flex-end',
    },
  },
  rightSideContainer: {
    mt: 16,
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderTop: '1px dashed $neutral4',
    paddingTop: 16,
    flex: 1,
    '@media(min-width: 390px)': {
      flexDirection: 'row',
    },
    '@xl': {
      paddingTop: 0,
      border: 'none',
      flexDirection: 'column',
      mt: 0,
      alignItems: 'flex-end',
    },
  },
  priceContent: {
    flexDirection: 'column',
    '@xl': {
      flexDirection: 'row',
    },
  },
  selectButton: {
    width: '100%',
    '@sm': {
      minWidth: 110,
    },
  },
  passengerVehicleContainer: {
    flexDirection: 'column',
    gap: 8,
    '@md': {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  bottomContainer: {
    flexDirection: 'column',
    alignItem: 'center',
    '@xl': {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
};
